import { useState, type JSX } from 'react';
import { ConversationTopicsPanel } from './ConversationTopicsPanel';
import '../styles/master-conversation.css';

/** Personal conversation has no subscription or composer connected to the operational MASTER. */
export function PersonalChatPage(): JSX.Element {
  const [topicId, setTopicId] = useState('');
  return (
    <main className="personal-chat" data-testid="personal-chat-page">
      <header className="personal-chat-heading">
        <div>
          <p className="product-kicker">SEU ORQUESTRADOR PESSOAL</p>
          <h1>Assistente</h1>
        </div>
        <span className="personal-chat-privacy">
          <span aria-hidden>●</span> Só você conduz
        </span>
      </header>
      <ConversationTopicsPanel activeTopicId={topicId} onActiveTopic={setTopicId} />
    </main>
  );
}
